import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog'

import { PurchaseForm } from './PurchaseForm'

export function AddPurchaseDialog({ open, onOpenChange, purchase }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-2xl max-h-[90vh] overflow-y-auto rounded-2xl sm:rounded-3xl p-4 sm:p-6 shadow-2xl">
        <DialogHeader>
          <DialogTitle>
            {purchase ? 'Edit Purchase Person' : 'Add Purchase Person'}
          </DialogTitle>
        </DialogHeader>

        <PurchaseForm
          key={purchase?._id || purchase?.id || 'new'}
          purchase={purchase}
          onCancel={() => onOpenChange(false)}
          onSuccess={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
